module.exports = __webpack_public_path__ + "static/media/btn_createbf1f4cf9ba1bc6ed235d5128aaee79b2.webp";